<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card mb-4">
					<div class="card-header pb-0">
						<h4>{{ $t('members') }}</h4>
						<button
							type="button"
							id="add-btn"
							class="btn btn-primary"
							@click="clear"
							data-bs-toggle="modal"
							data-bs-target="#formModal"
						>
							+ {{ $t('add').toUpperCase() }}
						</button>
					</div>
					<div class="card-body px-0 pt-0 pb-2">
						<custom-table
							ref="table$"
							:rows="data"
							@action="runAction"
							:columns="[
								{
									title: 'Nome Cognome',
									type: 'member-avatar',
									data: 'memberObject',
								},
								{
									title: 'Tessera',
									type: 'member-card',
									data: 'memberObject',
								},
								{
									title: 'Data di scadenza',
									type: 'date',
									data: 'date',
								},
							]"
							:actions="[
								{
									title: 'Cancella',
									tooltip: 'delete',
									key: 'delete',
								},
								{
									title: 'Modifica',
									tooltip: 'edit',
									key: 'edit',
								},
							]"
							:pagination="pagination"
							@page-changed="handlePageChange"
							@update-pagination="handlePaginationUpdate"
							@search-changed="handleSearchChange"
						/>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="formModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="add"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formModalBtn">{{ modalTitle }}</h5>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							style="color: black; font-size: 2rem"
						>
							<span
								aria-hidden="true"
								class="d-block"
								style="margin-top: -0.5rem"
								>&times;</span
							>
						</button>
					</div>
					<div class="modal-body">
						<Vueform ref="form$" v-model="member" sync>
							<HiddenElement name="id" />
							<text-element
								name="first_name"
								:label="$t('first_name')"
								rules="required"
							></text-element>
							<text-element
								name="last_name"
								:label="$t('last_name')"
								rules="required"
							></text-element>
							<text-element
								name="username"
								:label="$t('username')"
								rules="required"
							></text-element>
							<text-element
								name="email"
								:label="$t('email')"
								rules="required|email"
							></text-element>
							<text-element
								name="password"
								input-type="password"
								:label="$t('password')"
								rules="required"
							></text-element>
							<text-element
								name="location"
								:label="$t('location')"
								rules=""
							></text-element>
							<text-element
								name="profession"
								:label="$t('profession')"
								rules=""
							></text-element>
							<text-element
								name="phone_number"
								:label="$t('phone_number')"
								rules=""
							></text-element>
							<hr />
							<!-- <MultifileElement
								name="photo_url"
								:object="true"
								url="https://equiup-api.13bit.dev/api/horse-images/get-photo"
								preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
								:upload-temp-endpoint="false"
								label="Upload Foto"
								view="gallery"
								:clickable="true"
								:drop="true"
								storeFile="url"
								:soft-remove="true"
							/> -->
						</Vueform>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							id="close"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Chiudi
						</button>
						<button
							type="button"
							class="btn btn-primary"
							:class="{ loading: loading }"
							@click="save"
						>
							Salva
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { membersService } from '@/services/MembersService';
	import CustomTable from '@/components/CustomTable';
	import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
	import { useTableData } from '../../src/composables/useTableData';
	import { useToast } from 'vue-toastification';
	const toast = useToast();

	export default {
		name: 'Soci',
		components: { CustomTable },
		data() {
			return {
				member: {},
				members: [],
				loading: false,
				modalTitle: this.$t('add'),
			};
		},
		computed: {
			userRoleId() {
				return this.$store.state.user.role_id;
			},
			ridingId() {
				return this.$store.state.user.riding_stables[0].id;
			},
		},
		setup() {
			const tableData = useTableData(
				membersService.getMembers.bind(membersService),
				10
			);
			return tableData;
		},

		methods: {
			runAction({ action, row }) {
				this.loading = true;
				if (action.key == 'edit') {
					this.modalTitle = this.$t('edit');
					this.member = membersService.getMemberById(row.id);
					this.member.id = row.id;
					this.loading = false;
					const modalElement = document.getElementById('formModal');
					const myModal = new bootstrap.Modal(modalElement);
					myModal.show();
				} else if (action.key == 'delete') {
					this.deleteMember(row.id);
				}
			},

			clear() {
				this.member = {};
				this.$refs.form$.reset();
				this.modalTitle = this.$t('add');
			},

			async save() {
				const form = this.$refs.form$;
				form.validate();
				if (this.member.id) form.data.id = this.member.id;
				if (!form.hasErrors) {
					for (const key in form.data) {
						if (form.data[key] === 'null' || form.data[key] === null) {
							delete form.data[key];
						}
					}
					this.loading = true;
					console.log(form.data);
					try {
						await membersService.saveMember(
							this.ridingId,
							this.userRoleId,
							form.data
						);
						toast(this.$t('operation_saved'));
						document.getElementById('close').click();
						this.fetchMembers();
					} finally {
						this.loading = false;
					}
				}
			},

			fetchMembers() {
				this.fetchData({
					riding_stable_id: this.ridingId,
					role_id: this.userRoleId,
				});
			},

			async deleteMember(member_id) {
				if (
					!confirm(
						this.$t('irreversible_action') + '\n' + this.$t('do_u_confirm')
					)
				)
					return;
				await membersService.deleteMember(
					this.ridingId,
					this.userRoleId,
					member_id
				);
				this.fetchMembers();
			},
		},
		created() {
			this.$store.dispatch('updateBreadcrumbs', [
				{ title: 'Soci', name: 'Soci' },
			]);
		},
		mounted() {
			this.fetchMembers();
		},
	};
</script>
